import { Button } from "@cms/components/data/Button"
import { ControlledSystemDialog } from "@cms/components/data/Dialog"
import { renderVersionInfo } from "@cms/utils/helpers"
import { useAppSelector } from "@cms/utils/store/hooks"
import { SaveStoryButton } from "./SaveStoryButton"

export const RestoreVersionButton = () => {
    const { currentVersion, lastPublishedVersionId } = useAppSelector((state) => state.editor)

    return (
        <ControlledSystemDialog
            dialogProps={{
                title: 'Restore version',
                maxWidth: 'sm'
            }}
            trigger={{
                component: (
                    <Button
                        inputVariant='white_text_dark_bg'
                        inputSize='xs'
                    >
                        Restore this version
                    </Button>
                ),
            }}
            content={{
                component: (
                    <div>
                        <p>Are you sure you want to restore this version?</p>
                        <p
                            dangerouslySetInnerHTML={{
                                __html: renderVersionInfo(currentVersion, lastPublishedVersionId)
                            }}
                        />
                    </div>
                )
            }}
            actionsProps={{
                submit: {
                    component: (
                        <SaveStoryButton
                            buttonProps={{
                                inputVariant: "white_text_red_bg",
                                children: "Yes, restore it"
                            }}
                        />
                    )
                }
            }}
        />
    )
}
